import GetQueryParam from '../util/get-query-param';

class IotHousingController {
    constructor () {

        this.setLifeSlider();
        this.setModalRenewal();

        let tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        let firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        this.player = null;
        this.playerbottom = null;
        window.onYouTubeIframeAPIReady = () => {
            this.player = new YT.Player('js-popup__movie', {
                // width: w,
                // height: h,
                videoId: $('#js-style-detail__movie-btn').data('yid'),
            });
            this.playerbottom = new YT.Player('js-popup__moviebottom', {
                // width: w,
                // height: h,
                videoId: $('#js-style-detail__moviebottom-btn').data('yid'),
            });
        };

        this.setPopupMovie();

        let q = new GetQueryParam();

        if (q.movie) {
            setTimeout(() => {
                $('#js-style-detail__movie-btn').trigger('click');
            }, 2500);
        }
    }

    setPopupMovie() {
        let $link = $('#js-style-detail__movie-btn');
        let $pop = $('.style-detail__movie-popup');
        let _this = this;
        $link.on('click', function (e) {
            e.preventDefault();
            $pop.toggleClass('is-open');
            _this.player.playVideo();
        });

        $pop.on('click', function (e) {
            e.preventDefault();
            // console.log(e.currentTarget);
            if ($(e.target).hasClass('is-open')) {
                $pop.removeClass('is-open');
                _this.player.pauseVideo();
            }
        });
        $('.common-popup__close').on('click', function (e) {
            e.preventDefault();
            $pop.removeClass('is-open');
            _this.player.pauseVideo();
        });
    }

    setLifeSlider() {
        let swiperThumbnail = new Swiper(".swiperThumbnail", {
            loop: true,
            loopAdditionalSlides: 4,
            centeredSlides: true,
            spaceBetween: 10,
            slidesPerView: "auto",
            slideToClickedSlide: true,
            navigation: {
                nextEl: '#style-detail__other-slide-next2',
                prevEl: '#style-detail__other-slide-prev2',
            },
        });
        let swiper2 = new Swiper(".mySwiper2", {
            loop: true,
            loopAdditionalSlides: 4,
            centeredSlides: true,
            loopedSlides: 4,
            effect: "fade",
            slidesPerView: "auto",
            thumbs: {
                swiper: swiperThumbnail,
            },
            fadeEffect: {
                crossFade: true
            },
            
            on: {
                slideChangeTransitionStart: function () {
                    let slides = document.querySelectorAll('.mySwiper2 .swiper-slide');
                    slides.forEach(slide => {
                        slide.style.opacity = '0';
                    });
                    let activeSlide = document.querySelector('.mySwiper2 .swiper-slide-active');
                    activeSlide.style.opacity = '1';
                }
            }
        });
        swiperThumbnail.on('transitionStart', function () {
            swiper2.slideTo(swiperThumbnail.activeIndex);
        });

        swiper2.on('transitionStart', function () {
            swiperThumbnail.slideTo(swiper2.activeIndex);
        });
    }

    setModalRenewal() {
        $('[data-modal2-trigger]').on('click', function () {
            let modalValue = $(this).data('modal2-trigger');
            let targetModal = $('[data-modal2-target="' + modalValue + '"]');
            if (targetModal.length) {
                targetModal.addClass('is-open');
                $('body').addClass('modal-open');
            }
        });

        $('[data-modal2-close]').on('click', function () {
            $(this).closest('.modal-type2').removeClass('is-open');
            if (!$('.modal-type2.is-open').length) {
                $('body').removeClass('modal-open');
            }
        });

        $('.modal-type2').on('click', function (event) {
            if (!$(event.target).closest('.modal-type2__inner').length) {
                $(this).removeClass('is-open');
                if (!$('.modal-type2.is-open').length) {
                    $('body').removeClass('modal-open');
                }
            }
        });
    }
}

export default IotHousingController;
